import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "MailFolderMoveToDialog" */ './lazyIndex'),
    { name: 'MailFolderMoveToDialog' }
);

export const lazyShowMoveToFolderDialogV9: LazyAction<
    typeof lazyIndex.showMoveToFolderDialogV9,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.showMoveToFolderDialogV9);

export const lazyShowRunRuleNowFolderDialog: LazyAction<
    typeof lazyIndex.showRunRuleNowFolderDialog,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.showRunRuleNowFolderDialog);

export type { MoveToFolderSelectorProps } from './types/MoveToFolderSelectorProps';
